export default __webpack_public_path__ + "static/media/20_header_quotation.86b27c81.png";